import { Injectable } from '@angular/core';

@Injectable()
export class UtilitarioService {

  public static retornaUnidadeUsuario(){
    var token = localStorage.getItem('Cardeal.Token');
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload).unidade;
  }

  public static adicionaZero(aux: number) {
    return (aux < 10) ? '0' + String(aux) : String(aux);
  }

  public static retornaDataPrimeiroDiaDoMes() {
    const auxData = new Date();
    auxData.setDate(auxData.getDate());
    return '01/' + UtilitarioService.adicionaZero(auxData.getMonth() + 1) + '/' + auxData.getFullYear();
  }

  public static retornaDataUltimoDiaDoMes() {
    const auxData = new Date();
    auxData.setDate(1);
    auxData.setMonth(auxData.getMonth() + 1);
    auxData.setDate(0);
    return UtilitarioService
      .adicionaZero(auxData.getDate()) + '/' + UtilitarioService.adicionaZero(auxData.getMonth() + 1) + '/' + auxData.getFullYear();
  }

  public static retornaDataUltimoDiaDoMesAnterior(mesesAnteriores: number) {
    const auxData = new Date();
    auxData.setDate(1);
    auxData.setMonth((auxData.getMonth() - mesesAnteriores) + 1);
    auxData.setDate(0);
    return UtilitarioService
      .adicionaZero(auxData.getDate()) + '/' + UtilitarioService.adicionaZero(auxData.getMonth() + 1) + '/' + auxData.getFullYear();
  }

  public static retornaDataAtualMaisDias(dias: number) {
    const auxData = new Date();
    auxData.setDate(auxData.getDate() + dias);
    return UtilitarioService
      .adicionaZero(auxData.getDate()) + '/' + UtilitarioService.adicionaZero(auxData.getMonth() + 1) + '/' + auxData.getFullYear();
  }

  public static retornaPrimeiraDataMesAtualISO(){
    const auxData = new Date();
    auxData.setDate(auxData.getDate());
    return UtilitarioService.adicionaZero(auxData.getFullYear())
    .concat('-')
    .concat(UtilitarioService.adicionaZero(auxData.getMonth() + 1))
    .concat('-')
    .concat(UtilitarioService.adicionaZero(1));
  }
  
  public static retornaDataAtualMaisDiasISO(dias: number) {
    const auxData = new Date();
    auxData.setDate(auxData.getDate() + dias);
    return UtilitarioService.adicionaZero(auxData.getFullYear())
      .concat('-')
      .concat(UtilitarioService.adicionaZero(auxData.getMonth() + 1))
      .concat('-')
      .concat(UtilitarioService.adicionaZero(auxData.getDate()));
  }

  public static retornaData(auxData: Date) {
    return UtilitarioService
      .adicionaZero(auxData.getDate()) + '/' + UtilitarioService.adicionaZero(auxData.getMonth() + 1) + '/' + auxData.getFullYear();
  }

  public static retornaDataISO(auxData: Date) {
    // FIXME: é necessário arrumar o valor do mês? Conferir!
    return this.adicionaZero(auxData.getFullYear()) + '-'
      + this.adicionaZero(auxData.getMonth() + 1) + '-' + this.adicionaZero(auxData.getDate());
  }

  public static retornaDataFormatBR(auxData: Date) {
    // FIXME: é necessário arrumar o valor do mês? Conferir!
    return this.adicionaZero(auxData.getDate()) + '-'
      + this.adicionaZero(auxData.getMonth() + 1) + '-'
      + this.adicionaZero(auxData.getFullYear());
  }

  public static retornaTipoMovimentacao(tipoMovimentacaoId: number): string {
    if (tipoMovimentacaoId.toString() === '1') {
      return '/mov/administrativa';
    } else if (tipoMovimentacaoId.toString() === '2') {
      return '/mov/execucao-provisoria';
    } else if (tipoMovimentacaoId.toString() === '3') {
      return '/mov/judicial';
    }
  }

  public static retornaCaminhoEditar(tipoMovimentacaoId: number, tipoMeAvise: string, idMeAvise: number): string {
    return this.retornaTipoMovimentacao(tipoMovimentacaoId) + '/' + tipoMeAvise + '/' + idMeAvise;
  }

  static convertModelToFormData(model: any, form: FormData = null, namespace = ''): FormData {
    const formData = form ? form : new FormData();

    for (const propertyName in model) {
      if (!model.hasOwnProperty(propertyName) || model[propertyName] === undefined) {
        continue;
      }

      const formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;

      if (model[propertyName] instanceof Date) {
        formData.append(formKey, model[propertyName].toISOString());
      } else if (model[propertyName] instanceof File) {
        formData.append(formKey, model[propertyName], model[propertyName].name);
      } else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          if (typeof element !== 'object') {
            formData.append(`${formKey}[]`, element);
          } else {
            const tempFormKey = `${formKey}[${index}]`;
            this.convertModelToFormData(element, formData, tempFormKey);
          }
        });
      } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File)) {
        this.convertModelToFormData(model[propertyName], formData, formKey);
      } else {
        formData.append(formKey, model[propertyName].toString());
      }
    }

    return formData;
  }

  private static getPrintCssAsString(): string {
    return `* {
      background:transparent!important;
      color:#000 !important;
      text-shadow:none !important;
      filter:none !important;
      -ms-filter:none !important;
    }

    @page {
      margin: 0.5cm;
    }

    body { font: 20px Georgia, "Times New Roman", Times, serif;
    color: #000;   text-align:left;padding:0;  margin:0;}

    h1 {font-size: 30px;}
    h2 {font-size: 12px;}
    h3 {font-size: 10px;}
    table {
      width: fit-content; 
      font-size:12px;
      text-align:left;
      margin-left:auto; 
      margin-right:auto;
    }

    table, th, td {border: solid 1px #DDD; border-collapse: collapse}

    p{
      margin-top: 3px;
      margin-bottom: -1px;
    }

    `;
  }

  private static getBoilerplateJsAsString() {
    return `function triggerPrint(event) {
    window.removeEventListener('load', triggerPrint, false);
    setTimeout(function() {
      closeWindow(window.print());
    }, 0);
    }
    function closeWindow(){
      window.close();
    }
    window.addEventListener('load', triggerPrint, false);`;
  }

  private static getBoilerplateForPrinting(tabTitle: string, style: string, js: string, filtros: string) {
    return `<html>
    <head>
      <title>${tabTitle}</title>
      <style>${style}</style>
    </head>
    <body>
      <h1>${tabTitle}</h1>
      <table style= "width: 40%; margin-left:0; margin-bottom:2%;">${filtros}</table>
      <div id="relatorio"></div>
      <script defer>${js}</script>
    </body>
  </html>`;
  }

  static imprimirNode(node: Node, tabTitle: string, filtros: string = '') {
    const popupWin = window.open('', '_blank');

    popupWin.document.open();
    popupWin.document.write(
      this.getBoilerplateForPrinting(
        tabTitle,
        this.getPrintCssAsString(),
        this.getBoilerplateJsAsString(),
        filtros)
    );

    let relDivRef = popupWin.document.getElementById("relatorio");
    relDivRef.appendChild(node);

    popupWin.document.close();
  }

  static imprimirHTML(conteudo: string, tabTitle: string, filtros: string = ''): string {
    const popupWin = window.open('', '_blank');

    popupWin.document.open();
    popupWin.document.write(
      this.getBoilerplateForPrinting(
        tabTitle,
        this.getPrintCssAsString(),
        this.getBoilerplateJsAsString(),
        filtros)
    );

    let relDivRef = popupWin.document.getElementById("relatorio");
    relDivRef.innerHTML = conteudo;

    popupWin.document.close();
    return conteudo
  }

  base64toBlob(b64Data: any, contentType: any) {
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  saveAs(blob: any, fileName: string) {
    const fileUrl = URL.createObjectURL(
      this.base64toBlob(
        blob.FileContents, blob.ContentType
      )
    );
    const downloadStrategy = document.createElement('a');
    document.body.appendChild(downloadStrategy);
    downloadStrategy.href = fileUrl;
    downloadStrategy.download = fileName;
    downloadStrategy.click();
    URL.revokeObjectURL(downloadStrategy.href);
  }



  // public static validaData(dateString: string) {
  //   // debugger;
  //   // First check for the pattern
  //   // if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
  //   //   return false;
  //   // }

  //   // Parse the date parts to integers
  //   let parts = dateString.split('-');
  //   let day = parseInt(parts[0], 10);
  //   let month = parseInt(parts[1], 10);
  //   let year = parseInt(parts[2], 10);

  //   // Check the ranges of month and year
  //   if (year < 1000 || year > 3000 || month === 0 || month > 12) {
  //     return false;
  //   }

  //   let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  //   // Adjust for leap years
  //   if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
  //     monthLength[1] = 29;
  //   }

  //   // Check the range of the day
  //   return day > 0 && day <= monthLength[month - 1];
  // }
}
